import React from 'react';
import { personalInfo } from '../data/portfolio';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" aria-labelledby="hero-heading">
      <div className="container">
        <div className="hero__content">
          <div className="hero__text">
            <p className="hero__eyebrow">Available for remote &amp; on-site work</p>
            <h1 id="hero-heading" className="hero__name">{personalInfo.name}</h1>
            <h2 className="hero__title">{personalInfo.title}</h2>
            <p className="hero__description">{personalInfo.bio}</p>

            <div className="hero__pipeline" aria-hidden="true">
              <span className="stage">TypeScript</span><span className="arrow">→</span>
              <span className="stage hi">React Native</span><span className="arrow">→</span>
              <span className="stage">EAS Build / CI-CD</span><span className="arrow">→</span>
              <span className="stage">App Store</span><span className="stage">&nbsp;·&nbsp;</span><span className="stage">Google Play</span>
            </div>

            <div className="hero__cta-group">
              <a href="#projects" className="btn btn--primary btn--lg hero__cta-primary">
                View Projects
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </a>
              <a href="#contact" className="btn btn--outline btn--lg hero__cta-secondary">Get In Touch</a>
            </div>

            <div className="hero__social" role="list" aria-label="Social links">
              <a href={personalInfo.links.github} className="hero__social-link" aria-label="GitHub" target="_blank" rel="noopener noreferrer">
                <svg width="19" height="19" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
              <a href={personalInfo.links.mementoPlayStore || "https://play.google.com/store/apps/details?id=com.zahirtanin.mementoLanguage&hl=en"} className="hero__social-link" aria-label="Memento Language on Google Play" target="_blank" rel="noopener noreferrer">
                <svg width="19" height="19" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="hero__visual">
            <div className="hero__portrait">
              <img src="/zahir.png" alt="Zahir Tanin" />
              <span className="hero__portrait-label">React Native Developer</span>
            </div>
            <div className="hero__phone-frame">
              <div className="hero__phone-screen">
                <div className="hero__phone-notch" />
                <div className="hero__app-preview">
                  <div className="hero__app-header">
                    <div className="hero__app-title">Memento</div>
                    <span className="hero__app-badge">LIVE</span>
                  </div>
                  <div className="hero__app-stats">
                    <div className="hero__stat">
                      <span className="hero__stat-value">AI</span>
                      <span className="hero__stat-label">Chat Practice</span>
                    </div>
                    <div className="hero__stat">
                      <span className="hero__stat-value">Live</span>
                      <span className="hero__stat-label">Voice / Video</span>
                    </div>
                    <div className="hero__stat">
                      <span className="hero__stat-value">SRS</span>
                      <span className="hero__stat-label">Vocabulary</span>
                    </div>
                  </div>
                  <div className="hero__app-chat">
                    <div className="hero__bubble hero__bubble--in">¿Cómo se dice "welcome" en español?</div>
                    <div className="hero__bubble hero__bubble--out">It's "bienvenido" 🎉</div>
                  </div>
                  <div className="hero__app-actions">
                    <button className="hero__action-btn hero__action-btn--primary">Practice</button>
                    <button className="hero__action-btn hero__action-btn--secondary">Call a Tutor</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="hero__floating-cards">
              <div className="hero__float-card hero__float-card--1">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" /></svg>
                <span>React Native</span>
              </div>
              <div className="hero__float-card hero__float-card--2">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
                <span>AWS Serverless</span>
              </div>
              <div className="hero__float-card hero__float-card--3">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
                <span>EAS CI/CD</span>
              </div>
            </div>
          </div>
        </div>

        <div className="hero__scroll-indicator" aria-hidden="true">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 5v14M19 12l-7 7-7-7" />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default Hero;
